module.exports = __webpack_public_path__ + "a68dd56f1c4ab4df95e24b714ebdb8d5.pdf";